import { useTranslation } from 'react-i18next'

import { ComboBox, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { weightUnits } from '@/common/constants'
import configurationServices from '@/configuration/services/services'

import CodeItem from './CodeItems/CodeItem'
import useCodeSearch from './hooks/useCodeSearch/useCodeSearch'
import { inventoryFields } from './constants'
import * as Styles from './styles'

const InventoryDefaultSection = ({
  regions,
  defaultHsCode,
  defaultHtsCode,
  defaultMidCode,
  defaultNsPid,
  defaultCountryCode,
  defaultWeight,
  defaultWeightUnit,
  needsHts,
  needsNsPid,
  onChange,
}) => {
  const { t } = useTranslation()
  const hsCodeSearch = useCodeSearch(configurationServices.getHsCodes, defaultHsCode)
  const htsCodeSearch = useCodeSearch(configurationServices.getHtsCodes, defaultHtsCode)

  const handleHsCodeChange = e => {
    hsCodeSearch.handleSelect(e.target.value)
    onChange(inventoryFields.hsCode, e.target.value)
  }

  const handleHtsCodeChange = e => {
    htsCodeSearch.handleSelect(e.target.value)
    onChange(inventoryFields.htsCode, e.target.value)
  }

  const handleNsPidChange = e => onChange(inventoryFields.nsPid, e.target.value)

  return (
    <Styles.Container>
      <Text type="titleM">{t('Valores por defecto para inventario')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define los valores por defecto que deben utilizarse para aduanas si no se definen explícitamente en los productos del inventario.'
        )}
      </Text>
      <Styles.FieldsGrid>
        <ComboBox
          label={t('Código HSCode por defecto para productos')}
          value={defaultHsCode}
          handleChange={handleHsCodeChange}
          onSearchChange={hsCodeSearch.handleSearchChange}
          menuItems={hsCodeSearch?.items?.map(item => ({
            value: item.code,
            label: <CodeItem code={item.code} description={item.description} />,
          }))}
          helperText={hsCodeSearch.selectedDescription}
          searchable
        />
        <ComboBox
          label={t('País de origen por defecto para productos')}
          value={defaultCountryCode}
          handleChange={e => onChange(inventoryFields.countryFrom, e.target.value)}
          menuItems={regions?.map(region => ({
            value: region.code,
            label: region.name,
          }))}
        />
        {needsHts && (
          <ComboBox
            label={t('Código HTS por defecto para productos')}
            value={defaultHtsCode}
            handleChange={handleHtsCodeChange}
            onSearchChange={htsCodeSearch.handleSearchChange}
            menuItems={htsCodeSearch?.items?.map(item => ({
              value: item.code,
              label: <CodeItem code={item.code} description={item.description} />,
            }))}
            helperText={htsCodeSearch.selectedDescription}
            searchable
          />
        )}
        {needsHts && (
          <InputWithLabel
            label={t('Código MID por defecto para productos')}
            value={defaultMidCode}
            onChange={e => onChange(inventoryFields.midCode, e.target.value)}
          />
        )}
        {needsNsPid && (
          <Styles.FullWidthField>
            <InputWithLabel
              label={t('Código NS-PID por defecto para productos')}
              value={defaultNsPid}
              onChange={handleNsPidChange}
              fullWidth
            />
          </Styles.FullWidthField>
        )}
        <InputWithLabel
          label={t('Peso por defecto para productos')}
          type="number"
          value={defaultWeight}
          onChange={e => onChange(inventoryFields.weight, e.target.value)}
        />
        <ComboBox
          label={t('Unidad de peso por defecto para productos')}
          value={defaultWeightUnit}
          handleChange={e => onChange(inventoryFields.weightUnit, e.target.value)}
          menuItems={weightUnits.map(unit => ({
            label: t(unit.label),
            value: unit.value,
          }))}
          fullWidth
        />
      </Styles.FieldsGrid>
    </Styles.Container>
  )
}

export default InventoryDefaultSection
